import { gql } from '@apollo/client'

export const GET_RECOMMENDED_UP_NEXT = gql`
  query getRecommendedUpNext($projectSlug: String!) {
    recommendedUpNextV2(projectSlug: $projectSlug) {
      content {
        id
        title {
          ... on ContentSeries {
            id
            project {
              id
              slug
            }
          }
          ... on ContentMovie {
            id
            project {
              id
              slug
            }
          }
          ... on ContentDisplayable {
            id
            name
            image(aspect: "16:9", category: ANGEL_KEY_ART_1) {
              cloudinaryPath
            }
          }
        }
        watchable {
          ... on Node {
            id
          }
          ... on ContentWatchableAvailability {
            watchableAt
            watchableAvailabilityStatus
          }
        }
      }
    }
  }
`
